import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { ApiService } from 'src/app/services/api.service';
import { UtilsService } from 'src/app/services/utils.service';
import { DataService } from 'src/app/services/data.service';
import { ChangeDetectorRef } from '@angular/core';
var geoParse = require('wellknown');
@Component({
  selector: 'app-budgetpopup',
  templateUrl: './budgetpopup.component.html',
  styleUrls: ['./budgetpopup.component.scss']
})

export class BudgetpopupComponent implements OnInit {
  @ViewChild(MatSort) sort: MatSort;
  formGroup: FormGroup | any;
  formTaskGroup: FormGroup | any;
  rfFormGroup: FormGroup | any;
  feedtaskFormGroup: FormGroup | any;
 isTask:boolean =false;
 projName: any;
 taskName: any;
 isFormTaskValid = false;
 isBudgetNameFocusedOrHasValue =false;
 isSaveClicked = false;
  intentOption: ({ name: string; value: number; description: string; key: string; } | { name: string; value: number; key: string; description?: undefined; })[];
  strategyOptions: ({ name: string; value: string; description: string; } | { name: string; value: string; description?: undefined; })[];
  TASKFREQUENCY: { name: string; value: number; color: string; selected: boolean; available: boolean; }[];
  purposeOption: { code: string; name: string; }[];
  resetButton: boolean = true;
  isBudgetEqual: boolean = true;
  darkTheme: boolean;
  tooltipImagePath: string;
  siteData: any = [];
  fetchError: boolean = true;
  fetchMessage: string = '';
  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private apiService: ApiService,
    private utilsService: UtilsService,
    private localStorageService: DataService,
    private cdr: ChangeDetectorRef,
  ) {
    this.localStorageService.darkTheme.subscribe((newValue) => {
      this.darkTheme = newValue;

      this.tooltipImagePath = this.darkTheme ? '../../../assets/images/union-dark.svg' : '../../../assets/images/union.svg';
    });
   }

  ngOnInit() {
   if(this.data?.data?.budgetName){
    this.isTask=true
   }

   if (this.data?.data?.budget) {
    this.isBudgetEqual = this.isRangesAreEqual(this.data?.data?.budget);
   }

    this.formGroup = new FormGroup({
      budgetName: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(25)]),
    });
    this.rfFormGroup = new FormGroup({
      sitename: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(25), Validators.pattern(/^[a-zA-Z0-9\s]+$/)])
    });
    this.feedtaskFormGroup = new FormGroup({
      taskPriority: new FormControl('fastest', [Validators.required]),
    });
    this.fetchError = false;
    this.fetchMessage = '';
    // this.rfFormGroup.valueChanges.subscribe(() => {
    //   const fetchValue = this.rfFormGroup.get('daysCount').value;

    //   let maximumCollections: number = 1;
    //   console.log('this.data.frequency',this.data);
    //   if (this.data.frequency === 0) maximumCollections = 2;
    //   else if (this.data.frequency === 1 &&
    //     (this.data.repeatFrequency === 'Weekly' || this.data.repeatFrequency === 'Monthly'))
    //     maximumCollections = this.data?.numberOfRepeats * 2;
    //   else maximumCollections = this.data?.differenceInDays * 2;

    //   if ((fetchValue < 1 || !this.utilsService.isPositiveWholeNumber(fetchValue))) {
    //     this.fetchError = true;
    //     this.fetchMessage = '';
    //   } else if (fetchValue > maximumCollections) {
    //     this.fetchError = true;
    //     this.fetchMessage = 'The maximum number of collections possible for the requested time of interest (TOI) is ' + maximumCollections+'.';
    //   } else  this.fetchError = false;
    // });
    
    this.formTaskGroup = new FormGroup({
      project: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(25)]),
      taskname: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(35)])
    });
    this.formTaskGroup.valueChanges.subscribe(() => {
      this.checkFormValidity();
    });
    this.apiService.intentOption().subscribe((response: any) => {
      this.intentOption = response;
    });
    this.strategyOptions = this.apiService.strategyOptions;
    this.TASKFREQUENCY = this.apiService.TASKFREQUENCY;
    this.apiService.getPurpose().subscribe((res: any) => {
      this.purposeOption = this.utilsService.sortPurposeOptions(res?.purposeList);
    });
    this.setData();
  }
  getSiteName(index: number): string {
    const site = this.siteData.find(s => s.siteId === index + 1);    
    return site ? site.siteName : '';
  }
setData() {
    // if (this.data?.selectedRow?.noOfCollections) {
    //   this.rfFormGroup.get('daysCount').setValue(this.data.selectedRow.noOfCollections);
    // }
  
    if (this.data?.selectedRow?.siteData) {
      this.siteData = this.data.selectedRow.siteData;
    }
  
    // Dynamically add form controls for each site
    if(this.data?.targetInMap){
    this.data?.targetInMap.forEach((_, index) => {
      const siteNameControlName = `sitename-${index}`;
      const siteName = this.getSiteName(index);
  
      // Add control only if it doesn't already exist
      if (!this.rfFormGroup.contains(siteNameControlName)) {
        this.rfFormGroup.addControl(
          siteNameControlName,
          new FormControl(siteName, [
            Validators.required,
            Validators.minLength(3),
            Validators.maxLength(25),
            Validators.pattern(/^[a-zA-Z0-9\s]+$/),
          ])
        );
      }
    });
  }
  
    // Trigger change detection to avoid ExpressionChangedAfterItHasBeenCheckedError
    this.cdr.detectChanges();
  }

  getrfDetails() {
    console.log('this.data.targetInMap',this.data.targetInMap);
    const siteData = this.data.targetInMap.map((point, index) => {
      const siteNameControlName = `sitename-${index}`;
      return {
        siteId: index + 1,
        siteName: this.rfFormGroup.get(siteNameControlName).value,
        target: JSON.stringify(geoParse(point)),
      };
    });

    const siteDetails = {
      siteData: siteData
    };
    return siteDetails;
  }
  onNoClick(action): void {
    if(action === "save"){
      this.isSaveClicked = true;
      this.resetButton = false;
      const budgetName = this.formGroup.value.budgetName;
      const rfFormGroup = this.getrfDetails();
      const data = {
        budgetName: budgetName,
        rfSiteAndCollection: rfFormGroup,
      };
      this.dialogRef.close({ action, data });
    }
    else if(action === "task"){
      this.isTask =true
      this.resetButton = true;;
      this.formGroup.reset();
    }else if(action==="save_task"){
      this.isSaveClicked = true;
      const formValues = this.formTaskGroup.value;
      const rfFormGroupValues = this.getrfDetails();
      const data = {
        ...formValues,
        rfSiteAndCollection: rfFormGroupValues,
        sensors: JSON.stringify(this.data.data.sensors),
        taskStrategy:this.strategyOptions[0],
        intent:this.intentOption[0],
        purpose:this.purposeOption[0]
      };
  
    
      this.dialogRef.close({ action, data });
    }else if(action === "cancel")
      {

        if(this.data.data.budgetName){
          this.dialogRef.close();

        }else{
          this.isTask =false
          this.resetFormGroup(this.formTaskGroup);
        }
         
    } else if(action === "feed_task") {
       const data = {
        sensors: this.data.data.sensors,
        taskPriority: this.data.data.taskPriority
      };
       this.dialogRef.close({ action, data });
    } else {
      this.dialogRef.close({ action });
    }
    
  }
  Space(event: any) {
    if (event.target.selectionStart === 0 && event.code === "Space") {
      event.preventDefault();
    }
  }
  nameChng(e: any, i: number) {
    if (i === 1) {
     
      if (e.target.value.length > 4) {
        this.projName = e.target.value;
      } else {
        this.projName = undefined;
      }
    } else {
      if (e.target.value.length > 4) {
        this.taskName = e.target.value;
      } else {
        this.taskName = undefined;
      }
    }
    
  }
  get fields() {
    return this.formTaskGroup.controls;
  }
  get budgetField(){
    return this.formGroup.controls;
  }
  resetSorting() {
    if (this.sort) {
      this.sort.sort({ id: '', start: 'asc', disableClear: false });
    }
  }
  updateAllComplete(e: any, i: number) {
    
  }
  checkFormValidity() {
    const formValid = this.formTaskGroup.valid;
  
    this.isFormTaskValid = formValid
  }
  preventFocus(event: Event) {
    event.preventDefault();
  }
  onFocus(controlName: string) {
    this.formGroup.get(controlName).markAsTouched();
    this.updateButtonState();
  }
  onFocusOrInput() {
    this.updateButtonState();
  }
  onBlur() {
    this.updateButtonState();
  }

  updateButtonState() {
    const budgetNameControl = this.formGroup.get('budgetName');
  
    this.isBudgetNameFocusedOrHasValue = budgetNameControl && (budgetNameControl.value?.length > 4 && budgetNameControl.touched);    
    if(this.isBudgetNameFocusedOrHasValue) this.resetButton = false;
  }
  resetFormGroup(formGroup: any) {
    formGroup.reset();
    Object.keys(formGroup.controls).forEach(key => {
      formGroup.get(key).markAsUntouched();
    });
  }
  onFocusProject(controlName: string) {
    this.formTaskGroup.get(controlName).markAsTouched();
  }

  isRangesAreEqual(budget: any[]): boolean {
    const budgetItem = budget[0];
    return budgetItem.minRange === budgetItem.maxRange;
  }

  isSaveButtonDisabled() {
    if (!this.isBroRF() && this.data.rfSignals != null) {
      return this.data.targetInMap.some((_, index) => {
        const siteName = document.getElementById('sitename-' + index) as HTMLInputElement;
        return !siteName || siteName.value.trim().length < 1;
      });
    }
    return false;
  }

isBroRF(): boolean {
  return this.data?.isBroRF || false;
}
}
